export default {
  show(msg, time) {
    const me = this;
    document.body.insertAdjacentHTML(
      'beforeend',
      `${'' + '<div class="toast">' + '<div class="toast-txt">'}${msg}</div>` +
        '</div>',
    );

    setTimeout(() => {
      me.hide();
    }, time || 2000);
  },

  hide() {
    if (document.querySelector('.toast')) {
      document
        .querySelector('.toast')
        .parentNode.removeChild(document.querySelector('.toast'));
    }
  },
};
